import { render, staticRenderFns } from "./WikiSideBar.vue?vue&type=template&id=6acafc2d"
import script from "./WikiSideBar.vue?vue&type=script&lang=js"
export * from "./WikiSideBar.vue?vue&type=script&lang=js"
import style0 from "./WikiSideBar.vue?vue&type=style&index=0&id=6acafc2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports